let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5FMP1"), load("2u53D"), load("St9Nk"), load("6AIMV"), load("fOegz")]).then(() => parcelRequire('hiMwI'));